import FilterParameter from "./FilterParameter"
import Select from 'react-select'
import './Filter.scoped.scss'

export default function FeaturedCustomFieldFilter({ id }) {
  const act = useAct()
  const { filter: filterName } = useSel((s) => s.rules.entities[id])
  const availableFilters = useSel((s) => s.availableFilters)
  const filter = availableFilters[filterName]
  const { parameters } = useSel((s) => s.rules.entities[id])
  const featuredCustomField = useSel((s) => s.local.featuredCustomFields.find(fcf => fcf.id === parameters.customFieldId))
  const { name, kind, options } = featuredCustomField

  const value = parameters.value
  const selectValue = kind === 'select' ? _.find(options, { value }) : value
  const updateValue = (value) => act.search.upsertFilterParameters(id, { value })

  return <div className="filter">
    <div className="components">
      <p className="label bold">{ name }</p>
      { kind === 'select' && <p className="label">is</p> }
      { kind !== 'select' && <div className="parameter">
        <FilterParameter id={id} name="operator" fields={filter.fields} />
      </div> }
      <div className="parameter">
        { kind === 'select' && <Select
            width={100}
            options={options}
            value={selectValue}
            onChange={(option) => updateValue(option.value)}
          /> }
          { kind !== 'select' && <input
            style={{ width: '150px' }}
            type="number"
            value={value}
            onChange={(e) => updateValue(e.target.value)}
          /> }
      </div>
    </div>
  </div>
}
